module.exports = __webpack_public_path__ + "img/c2.c9a6af1a.png";